import { render, staticRenderFns } from "./contactWithUs.vue?vue&type=template&id=235fe12b&scoped=true"
import script from "./contactWithUs.vue?vue&type=script&lang=js"
export * from "./contactWithUs.vue?vue&type=script&lang=js"
import style0 from "./contactWithUs.vue?vue&type=style&index=0&id=235fe12b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235fe12b",
  null
  
)

export default component.exports